import { motion } from "framer-motion";
import { scrollToTarget } from "@/lib/lenis";

export const Nav = () => (
  <motion.header
    data-testid="site-nav"
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
    className="fixed top-0 left-0 right-0 z-50 bg-cream border-b border-soil/10"
  >
    <div className="flex items-center justify-between px-6 md:px-12 py-4">
      <button
        data-testid="nav-logo"
        onClick={() => scrollToTarget("#top")}
        className="font-serif text-xl md:text-2xl tracking-tight text-soil"
      >
        Embodied <span className="italic text-amethyst">Awakening</span>
      </button>
      <div className="flex items-center gap-6">
        <button
          data-testid="nav-journey-link"
          onClick={() => scrollToTarget("#journey")}
          className="hidden md:block text-xs uppercase tracking-[0.2em] text-clay hover:text-amethyst transition-colors duration-300"
        >
          The Journey
        </button>
        <button
          data-testid="nav-about-link"
          onClick={() => scrollToTarget("#about")}
          className="hidden md:block text-xs uppercase tracking-[0.2em] text-clay hover:text-amethyst transition-colors duration-300"
        >
          Amaléya
        </button>
        <button
          data-testid="nav-enquire-button"
          onClick={() => scrollToTarget("#enquire")}
          className="rounded-full bg-gold text-soil text-xs uppercase tracking-[0.18em] px-6 py-3 hover:bg-amethyst hover:text-cream transition-colors duration-300"
        >
          Enquire
        </button>
      </div>
    </div>
  </motion.header>
);
